export default __webpack_public_path__ + "static/media/Bg-5.c1f79ae8.png";